import { createSubmit } from 'vtils'
import { Toast } from 'vant'

let loading = undefined

export const submit = createSubmit({
  start(message) {
    loading = Toast.loading({
      duration: 0,
      // 应设为 false，不然如果 loading 状态下需要微信弹窗登录，其添加的 css 会导致弹窗不可点击
      // 已移到 login_dialog 用 css 做兼容，避免重复点击
      forbidClick: true,
      message: message,
    })
  },
  success(message, duration) {
    Toast.success({
      message: message,
      duration: duration,
    })
  },
  complete() {
    loading?.close()
  },
  fail(message, duration) {
    Toast({
      message: message,
      duration: duration,
    })
  },
  throw() {
    loading?.close()
  },
})
